module.exports = __webpack_public_path__ + "static/img/end-tit.50e28b2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/end-tit.png
// module id = 2gzz
// module chunks = 0